import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "relative w-full max-w-sm rounded-xl bg-white shadow-xl",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "flex items-center gap-3 border-b border-gray-100 px-5 py-4" }
const _hoisted_3 = { class: "flex h-8 w-8 flex-none items-center justify-center rounded-full bg-red-100" }
const _hoisted_4 = { class: "flex-1 text-sm font-semibold text-gray-900" }
const _hoisted_5 = { class: "divide-y divide-gray-100 px-2 py-2" }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "flex-1 text-sm font-medium text-gray-700" }

import { onKeyStroke } from '@vueuse/core';
import { computed } from 'vue';
import { AlertTriangle, ChevronRight, Loader2, X } from 'lucide-vue-next';
import { store } from '@/plugins/store';
import { ActionType } from '@/plugins/store/actions';
import FadeTransition from '@/components/transitions/FadeTransition.vue';
import type { SectionAlarm } from '@/types/SectionLiveKpi';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlarmHandleModal',
  props: {
    open: { type: Boolean },
    alarms: {},
    isLoading: { type: Boolean }
  },
  emits: ["close", "selectAlarm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Alarm type lookup from the store. GetAlarmTypes is lightweight and already loaded by the alarm log;
// if not yet loaded, dispatch it now so subsequent opens are instant.
const alarmTypes = computed(() => store.state.alarmTypes);

function alarmTypeName(typeId: number): string {
    const match = alarmTypes.value?.find((t) => t.id === typeId);
    return match?.name ?? `Alarm #${typeId}`;
}

// Severity level: 3 = error (red), 2 = warning (amber), 1 = ok (green).
function severityColour(level: number): string {
    if (level >= 3) return 'bg-red-500';
    if (level >= 2) return 'bg-amber-400';
    return 'bg-green-500';
}

// Ensure alarm types are in the store so the list can show meaningful labels.
if (!alarmTypes.value) {
    store.dispatch(ActionType.GetAlarmTypes, {});
}

onKeyStroke('Escape', () => {
    if (props.open) emit('close');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(FadeTransition, null, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[1030] flex items-center justify-center bg-black/40 p-4",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('close')), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(AlertTriangle), {
                      class: "h-4 w-4 text-red-600",
                      "aria-hidden": "true"
                    })
                  ]),
                  _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('views.monitoring.activeGroups.alarmHandle.title')), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
                  }, [
                    _createVNode(_unref(X), {
                      class: "h-4 w-4",
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alarms, (alarm) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: alarm.id
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors hover:bg-gray-50 disabled:opacity-50",
                        disabled: _ctx.isLoading,
                        onClick: ($event: any) => (emit('selectAlarm', alarm.id))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["h-2 w-2 shrink-0 rounded-full", severityColour(alarm.severity_level)])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(alarmTypeName(alarm.type_id)), 1),
                        (_ctx.isLoading)
                          ? (_openBlock(), _createBlock(_unref(Loader2), {
                              key: 0,
                              class: "h-3.5 w-3.5 shrink-0 animate-spin text-gray-400",
                              "aria-hidden": "true"
                            }))
                          : (_openBlock(), _createBlock(_unref(ChevronRight), {
                              key: 1,
                              class: "h-3.5 w-3.5 shrink-0 text-gray-400",
                              "aria-hidden": "true"
                            }))
                      ], 8, _hoisted_6)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})